export const ExportButton = ({onExport}) => (
	<button title="Exportar CSV" className="flex items-center rounded-md bg-blue-600 px-2 py-1 text-white" onClick={e => onExport(e.target.value)}>
		<ion-icon name="download-outline"></ion-icon>
	</button>
);
